import React, { FC } from 'react'

import { pluralize } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'
import { InputBasedFilter } from './FiltersVariations/Input'

interface ExactBedroomsFilterProps extends FiltersSharedProps {
  initialValue?: string
  onChange: (value?: string) => void
}

export const ExactBedroomsFilter: FC<ExactBedroomsFilterProps> = props => {
  const { initialValue } = props

  return (
    <InputBasedFilter
      title="Exact Bedrooms"
      type="number"
      placeholder="0"
      {...props}
      tagSuffix={initialValue && pluralize(parseInt(initialValue, 10), 'bedrooms', 'bedroom')}
    />
  )
}
